
    import './styles.scoped.css';
    export default {
  "drawer": "awsui_drawer_1r9lg_vwg33_189",
  "refresh": "awsui_refresh_1r9lg_vwg33_189",
  "animating": "awsui_animating_1r9lg_vwg33_203",
  "preference-icon--layout-border": "awsui_preference-icon--layout-border_1r9lg_vwg33_226",
  "preference-icon--layout-background": "awsui_preference-icon--layout-background_1r9lg_vwg33_230",
  "preference-icon--layout-header": "awsui_preference-icon--layout-header_1r9lg_vwg33_233",
  "preference-icon--border": "awsui_preference-icon--border_1r9lg_vwg33_236",
  "preference-icon--primary-button": "awsui_preference-icon--primary-button_1r9lg_vwg33_240",
  "preference-icon--secondary": "awsui_preference-icon--secondary_1r9lg_vwg33_243",
  "preference-icon--disabled-element": "awsui_preference-icon--disabled-element_1r9lg_vwg33_246",
  "preference-icon--separator": "awsui_preference-icon--separator_1r9lg_vwg33_249",
  "preference-icon--focus-text": "awsui_preference-icon--focus-text_1r9lg_vwg33_252",
  "preference-icon-refresh--layout-top": "awsui_preference-icon-refresh--layout-top_1r9lg_vwg33_256",
  "preference-icon-refresh--layout-main": "awsui_preference-icon-refresh--layout-main_1r9lg_vwg33_259",
  "preference-icon-refresh--primary": "awsui_preference-icon-refresh--primary_1r9lg_vwg33_262",
  "preference-icon-refresh--disabled": "awsui_preference-icon-refresh--disabled_1r9lg_vwg33_265",
  "preference-icon-refresh--column-header": "awsui_preference-icon-refresh--column-header_1r9lg_vwg33_268",
  "preference-icon-refresh--window": "awsui_preference-icon-refresh--window_1r9lg_vwg33_271",
  "preference-icon-refresh--secondary": "awsui_preference-icon-refresh--secondary_1r9lg_vwg33_275",
  "preference-icon-refresh--default": "awsui_preference-icon-refresh--default_1r9lg_vwg33_278",
  "preference-icon-refresh--separator": "awsui_preference-icon-refresh--separator_1r9lg_vwg33_281",
  "preference-icon-refresh--input-default": "awsui_preference-icon-refresh--input-default_1r9lg_vwg33_284",
  "preference-icon-refresh--heading": "awsui_preference-icon-refresh--heading_1r9lg_vwg33_287",
  "root": "awsui_root_1r9lg_vwg33_291",
  "preferences-button": "awsui_preferences-button_1r9lg_vwg33_304",
  "close-button": "awsui_close-button_1r9lg_vwg33_308",
  "drawer-closed": "awsui_drawer-closed_1r9lg_vwg33_320",
  "drawer-content-side": "awsui_drawer-content-side_1r9lg_vwg33_325",
  "drawer-content-bottom": "awsui_drawer-content-bottom_1r9lg_vwg33_341",
  "position-bottom": "awsui_position-bottom_1r9lg_vwg33_350",
  "position-side": "awsui_position-side_1r9lg_vwg33_377",
  "slider": "awsui_slider_1r9lg_vwg33_383",
  "slider-side": "awsui_slider-side_1r9lg_vwg33_412",
  "slider-wrapper-bottom": "awsui_slider-wrapper-bottom_1r9lg_vwg33_417",
  "slider-wrapper-side": "awsui_slider-wrapper-side_1r9lg_vwg33_428",
  "open-button": "awsui_open-button_1r9lg_vwg33_439",
  "open-button-side": "awsui_open-button-side_1r9lg_vwg33_443",
  "slider-icon": "awsui_slider-icon_1r9lg_vwg33_450",
  "slider-icon-bottom": "awsui_slider-icon-bottom_1r9lg_vwg33_456",
  "slider-icon-side": "awsui_slider-icon-side_1r9lg_vwg33_459",
  "pane-header-wrapper-bottom": "awsui_pane-header-wrapper-bottom_1r9lg_vwg33_463",
  "drawer-mobile": "awsui_drawer-mobile_1r9lg_vwg33_473",
  "drawer-disable-content-paddings": "awsui_drawer-disable-content-paddings_1r9lg_vwg33_476",
  "content-bottom": "awsui_content-bottom_1r9lg_vwg33_484",
  "pane-bottom-center-align": "awsui_pane-bottom-center-align_1r9lg_vwg33_497",
  "pane-bottom-content-nav-padding": "awsui_pane-bottom-content-nav-padding_1r9lg_vwg33_502",
  "pane-bottom-content-tools-padding": "awsui_pane-bottom-content-tools-padding_1r9lg_vwg33_506",
  "content-bottom-max-width": "awsui_content-bottom-max-width_1r9lg_vwg33_510",
  "content-side": "awsui_content-side_1r9lg_vwg33_515",
  "pane-header-wrapper-side": "awsui_pane-header-wrapper-side_1r9lg_vwg33_526",
  "pane-content-wrapper-side": "awsui_pane-content-wrapper-side_1r9lg_vwg33_530",
  "header": "awsui_header_1r9lg_vwg33_535",
  "header-text": "awsui_header-text_1r9lg_vwg33_544",
  "header-actions": "awsui_header-actions_1r9lg_vwg33_555",
  "divider": "awsui_divider_1r9lg_vwg33_563"
};
  